export default "__VITE_ASSET__WGLORMdL__"